import { CustomModalCell } from '../../components/custom-modal-cell';
import { CustomTrailerCell } from './components/custom-trailer-cell';

export const FORM_NAME = 'trailers-form';

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const TRAILER_TABLE_COLUMNS_NAMES = [
	{ id: 'title' },
	{ id: 'value', customComponent: CustomModalCell },
	{ id: 'mode', customComponent: CustomTrailerCell },
];

export const TRAILER_TABLE_ROWS_NAMES = {
	company: 'Компания',
	legal: 'Юр. лицо',
	number: 'Гос. номер',
	vin: 'Vin номер',
	type: 'Тип прицепа',
	dateIssue: 'Год выпуска прицепа',
	typeDateIssue: 'Год выпуска рефрижератора',
	weight: 'Грузоподъемность',
	volume: 'Вместимость',
	ownership: 'Тип владения',
	docName: 'Название документа',
	docNumber: 'Номер документа',
	docDate: 'Дата выдачи документа',
	isAccredited: 'Прицеп аккредитован',
	author: 'Автор',
};

export const FIELDS_FOR_VALIDATE = [
	'legal_id',
	'name',
	'number',
	'type_id',
	'date_issue',
	'weight',
	'volume',
	'ownership_id',
	'doc_name',
	'doc_number',
	'doc_date',
];

export const FORM_FIELDS = [
	'legal_id',
	'name',
	'number',
	'vin',
	'type_id',
	'date_issue',
	'type_date_issue',
	'weight',
	'volume',
	'ownership_id',
	'doc_name',
	'doc_number',
	'doc_date',
	'modes',
];

export const TYPES_WITH_DATE_ISSUE_AND_MODES = ['1'];
